module.exports = __webpack_public_path__ + "img/migration.dce8ed7a.png";